import { useEffect } from 'react';
import { Box, Fade } from '@mui/material';

import TrustPilot from '../TrustPilot';

import useEventTracking from 'modules/common/components/AnalyticsTracking/useEventTracking';

export default function TrustPilotCsatSurvey({
    open,
    score,
    surveyType,
    featureName,
    featureSection,
    onOpen,
}: {
    open: boolean;
    score: number;
    onOpen: () => void;
    surveyType: string;
    featureName: string;
    featureSection: string;
}) {
    const { sendTrackingEvent } = useEventTracking();

    useEffect(() => {
        if (open) {
            onOpen();
            sendTrackingEvent('CSAT TrustPilot Survey Viewed', {
                category: 'CSAT Survey',
                action: 'viewed',
                score,
                surveyType,
                featureName,
                featureSection,
            });
        }
    }, [open]);

    return (
        <Fade in={open} timeout={200} appear>
            <Box
                sx={{
                    display: open ? 'block' : 'none',
                    position: 'relative',
                    width: { xs: '100%', sm: '380px' },
                    height: '1000px',
                    maxHeight: '80dvh',
                    border: '1px solid',
                    borderColor: 'grey.100',
                    borderRadius: '4px',
                    marginTop: '20px',
                    overflow: 'hidden',
                }}>
                <TrustPilot />
            </Box>
        </Fade>
    );
}
